export default function jsonLdPreview(content) {
  let image = content.preview;

  return JSON.stringify(
    {
      "@context": "http://schema.org",
      "@type": "ImageObject",
      author: content.rightholder.name,
      contentUrl: image,
      datePublished: content.publishAt,
      description: content.description,
      name: content.title,
    },
    null,
    2
  );
}
